module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.newPricingAgreement')))]), _vm._v(" "), _c('p', {
    staticClass: "mb-10"
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.orImportLink')) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.index',
        query: {
          import: '1'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.importFromTemplateLink')))]), _vm._v(".")], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.customer'),
      "required": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.selectCustomer'),
      "filterable": ""
    },
    model: {
      value: (_vm.form.client_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "client_id", $$v)
      },
      expression: "form.client_id"
    }
  }, _vm._l((_vm.clients), function(c) {
    return _c('el-option', {
      key: c.id,
      attrs: {
        "label": c.name,
        "value": c.id,
        "disabled": c.system_generated === 1
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.name'),
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('pricingAgreements.namePlaceholder')
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validFrom'),
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": _vm.$t('pricingAgreements.from')
    },
    model: {
      value: (_vm.form.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.form, "valid_from", $$v)
      },
      expression: "form.valid_from"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.validTo'),
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": _vm.$t('pricingAgreements.to')
    },
    model: {
      value: (_vm.form.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.form, "valid_to", $$v)
      },
      expression: "form.valid_to"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('pricingAgreements.active')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.is_active),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_active", $$v)
      },
      expression: "form.is_active"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.createButton')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pricingAgreements.index',
        query: {
          filter: 'active'
        }
      }
    }
  }, [_c('el-button', {
    staticClass: "pricing-agreement-back-btn",
    attrs: {
      "type": "default",
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.$t('pricingAgreements.cancel')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5733d2cc","hasScoped":true}!./src/app/pages/withNavigation/pricingAgreements/create/create.html
// module id = 3017
// module chunks = 1